<div class="content">
  <Info
    title="Hoeveel slaapkamers wenst u?"
    details={window.zoekModalOptions.slaapkamer_text}
    imgSrc={window.zoekModalOptions.slaapkamer_image} />
  <div class="inputs">
    <span>Selecteer een optie:</span>

    <div>
      {#each [13, 14, 15, 16] as key, i}
        <div class="input-wrap">
          <input id={`input-${key}`} type="radio" name="3-bedroom" value={i + 1} bind:group={bedroom} />
          <label for={`input-${key}`}>
            <Check />
            <span>{i + 1} of meer</span>
          </label>
        </div>
      {/each}
    </div>
  </div>
</div>

<script>
  import Info from "./Info.svelte";
  import Check from "./Check.svelte";
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  let bedroom = [];
  $: dispatch('complete', bedroom);
</script>

<style lang="postcss">
  .content {
    @apply relative mx-5 pt-8 leading-7;
  }

  .inputs {
    @apply p-12 pt-16 border border-t-0;
  }

  .inputs > span {
    @apply inline-block w-full mb-5 text-center;
  }

  label {
    @apply mt-5 block relative px-5 py-6 flex border items-center;
  }

  label span {
    @apply ml-5;
  }

  input:checked + label {
    @apply bg-primary;
  }

  input:checked + label span {
    @apply text-white;
  }

  input:checked + label :global(svg path) {
    display: initial;
  }

  input {
    @apply hidden;
  }

  @screen sm {
    .content {
      @apply mx-12;
    }

    .inputs {
      @apply p-16 mr-16;
    }

    .inputs > span {
      @apply text-left;
    }

    .inputs > div {
      @apply flex flex-wrap;
    }

    .input-wrap {
      @apply w-1/2 px-2;
    }
  }

  @screen md {
    .content {
      @apply flex items-start;
    }

    .content :global(.info) {
      @apply bg-white;
    }

    .inputs {
      @apply mt-10 -ml-16 pl-32 border-t w-full mr-20;
    }

    .inputs > div {
      @apply max-w-2xl;
    }

    label {
      @apply w-full;
    }
  }
</style>
